import useAttributeList from 'api/codingAttribute/useAttributeList/useAttributeList';
import useDeleteAttribute from 'api/codingAttribute/useDeleteAttribute/useDeleteAttribute';
import DeleteCodeAttributeModal from 'components/private/CodingAttribute/DeleteCodeAttributeModal';
import CodeAttributeEditModal from 'components/shared/Modals/codeAttribute/CodeAttributeEditModal/CodeAttributeEditModal';
import CodeAttributeInsertModal from 'components/shared/Modals/codeAttribute/CodeAttributeInsertModal/CodeAttributeInsertModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useTableAttributeColumns from 'hooks/codingAttribute/useTableAttributeColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const CodingAttribute = () => {
  const { guid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getAttributeList, loading, attributeList, pageRef] =
    useAttributeList(guid);

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenAttr, setEditChosenAttr] = useState({});

  const { deleteRequest, deleteLoading } = useDeleteAttribute();

  const tableRef = useRef(null);
  const { can } = usePermissions();

  const valuesPermissions =
    permissions.general.categories.globalSettings.coddingSettings.groupCode
      .values;

  const canCreate = can(valuesPermissions.create);
  const canEdit = can(valuesPermissions.edit);
  const canDelete = can(valuesPermissions.delete);

  useEffect(() => {
    if (!guid) return;
    getAttributeList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    setPage(1);
  }, [pageSize]);

  useEffect(() => {
    if (!guid) return;
    getAttributeList({ page, count: pageSize });
  }, [pageSize]);

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenAttr(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = useTableAttributeColumns(
    deleteItem,
    editItem,
    tableRef,
    {
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = alternativeGuid => {
    deleteRequest({
      guid: deleteChosenLocation.id,
      alternativeGuid,
      onSuccess: () => {
        getAttributeList({
          page,
          count: pageSize,
          term: lastSearch,
        });
        setIsDeleteModalOpen(false);
      },
    });
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getAttributeList({
      page: pageNumber,
      count: pageSize,
      term: lastSearch,
    });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getAttributeList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>
      {Object.keys(attributeList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={attributeList[page]}
          rows={attributeList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت مقدار' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}
      {canDelete ? (
        <DeleteCodeAttributeModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          guid={deleteChosenLocation.id}
          groupGuid={guid}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canCreate && isInsertModalOpen ? (
        <CodeAttributeInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getAttributeList={getAttributeList}
          groupGuid={guid}
        />
      ) : null}
      {canEdit ? (
        <CodeAttributeEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenBasket={editChosenAttr}
          getAttributeList={getAttributeList}
        />
      ) : null}
    </>
  );
};

export default CodingAttribute;
